import { AppRoute } from '../routes.types';

export const PROTOTYPES_ROUTES: AppRoute[] = [];
